const statamicCollections = ["pages", "partials", "pro_news", "legal"] as const;

type StatamicCollection = (typeof statamicCollections)[number];

const statamicCollectionEntries = (collection: StatamicCollection) =>
  `/api/collections/${collection}/entries` as const;

export { statamicCollectionEntries, statamicCollections };
export type { StatamicCollection };
